import TenantProfile from './TenantProfile'

export default TenantProfile
